export const UserStatus = {
	offline: 'offline',
	online: 'online',
	mobileOnline: 'mobile-online',
	away: 'away',
	idle: 'idle',
	dnd: 'dnd',
	break: 'break',
};

export const UserType = {
	user: 'user',
	bot: 'bot',
	extranet: 'extranet',
	collaber: 'collaber',
	guest: 'guest',
};

export const UserRole = {
	guest: 'guest',
	member: 'member',
	manager: 'manager',
	owner: 'owner',
	none: 'none',
};

export const UserIdNetworkPrefix = 'network';
